/*
      ___           ___
     /\  \         /\  \
    /::\  \       /::\  \
   /:/\:\  \     /:/\ \  \
  /::\ \:\  \   _\:\ \ \  \
 /:/\:\ \:\__\ /\ \:\ \ \__\
 \/_|::\/:/  / \:\ \:\ \/__/
    |:|::/  /   \:\ \:\__\
    |:|\/__/     \:\/:/  /
    |:|  |        \::/  /
     \|__|         \/__/

    Developed by Ralph Shippam - 2019.
*/

import {RSDialog} from '../rsnotify/rsdialog';
import {ThemePalette} from '@angular/material/core';

export enum RSLoadingModalSpinner {
    MatSpinner,
    MatIcon,
    SpinKit,
    Progress,
    Component
    // TODO: FaIcon
}

export enum RSLoadingModalIconAnimation {
    Spin, Shake // TODO: Pulse?
}

export enum RSLoadingModalSpinkitType {
    ChasingDot, Circle, CubeGrid, DoubleBounce,
    FadingCircle, FoldingCube, Pulse, RotatingPlane,
    ThreeBounce, WanderingCubes, Wave, WordPress
}

export interface IRSLoadingModalDefaults {
    type?: RSLoadingModalSpinner;

    // MatSpinner
    color?: ThemePalette | ThemePalette[]; // Primary, accent or warn

    // MatSpinner && MatIcon && SpinKit
    size?: number; // Px

    // MatIcon
    icon?: string;
    iconAnimation?: RSLoadingModalIconAnimation;

    // SpinKit
    spinkit?: RSLoadingModalSpinkitType;

    beforeUnloadProtection?: boolean;
    timeout?: number; // milliseconds // TODO:
    minimumDisplayTime?: number; // milliseconds // TODO:
    dialogConfig?: RSDialog.Options;
}

export class RSLoadingModalDefaults {
    type: RSLoadingModalSpinner = RSLoadingModalSpinner.MatSpinner;
    color: ThemePalette | ThemePalette[] = 'primary';
    progress: boolean = false;

    size: number = 50;

    icon: string = null;
    iconAnimation: RSLoadingModalIconAnimation = RSLoadingModalIconAnimation.Spin;

    spinkit: RSLoadingModalSpinkitType = RSLoadingModalSpinkitType.ChasingDot;

    beforeUnloadProtection = true;

    timeout: number = 0; // milliseconds // TODO:
    minimumDisplayTime: number = 0; // milliseconds // TODO:
    dialogConfig: RSDialog.Options = {
        closeOnNavigation: true,
        disableClose: true,
        hasBackdrop: true,
        data: {}
    } as RSDialog.Options;

    constructor(modalDefaults: IRSLoadingModalDefaults = {}) {
        if (modalDefaults.hasOwnProperty('type')) {
            this.type = modalDefaults.type;
        }
        if (modalDefaults.hasOwnProperty('beforeUnloadProtection')) {
            this.beforeUnloadProtection = !!modalDefaults.beforeUnloadProtection;
        }
        if (modalDefaults.hasOwnProperty('color')) {
            this.color = modalDefaults.color;
        }
        if (modalDefaults.hasOwnProperty('size')) {
            this.size = modalDefaults.size;
        }
        if (modalDefaults.hasOwnProperty('icon')) {
            this.icon = modalDefaults.icon;
        }
        if (modalDefaults.hasOwnProperty('iconAnimation')) {
            this.iconAnimation = modalDefaults.iconAnimation;
        }
        if (modalDefaults.hasOwnProperty('spinkit')) {
            this.spinkit = modalDefaults.spinkit;
        }
        if (modalDefaults.hasOwnProperty('timeout')) {
            this.timeout = modalDefaults.timeout;
        }
        if (modalDefaults.hasOwnProperty('minimumDisplayTime')) {
            this.minimumDisplayTime = modalDefaults.minimumDisplayTime;
        }
        if (modalDefaults.hasOwnProperty('dialogConfig')) {
            this.dialogConfig = modalDefaults.dialogConfig;
        }
    }
}
